import { useMutation } from '@tanstack/react-query';

import axiosClient from '@/lib/axios';
import { getCookie } from '@/utils/storage';
import { queryClient } from '@/lib/react-query';

import type { CreateAnalyticsPayload, CreateAnalyticsResponse } from '../types';

export const createAnalytics = ({ company_id, payload }: { company_id: number; payload: CreateAnalyticsPayload }) => {
  const reqURL = payload.hash ? '/public/data-rooms/analytics' : `/companies/${company_id}/data-rooms/analytics`;
  return axiosClient.put<CreateAnalyticsResponse>(reqURL, { ...payload }).then((res) => res.status);
};

export const createAnalyticsKeepalive = ({
  company_id,
  payload,
}: {
  company_id: number;
  payload: CreateAnalyticsPayload;
}) => {
  const reqURL = payload.hash ? '/public/data-rooms/analytics' : `/companies/${company_id}/data-rooms/analytics`;
  const token = getCookie('access_token');

  return fetch(`${axiosClient.defaults.baseURL}${reqURL}`, {
    method: 'PUT',
    keepalive: true,
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(payload),
  });
};

export const useCreateAnalytics = () => {
  return useMutation({
    mutationFn: createAnalytics,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['analytics'] });
      void queryClient.invalidateQueries({ queryKey: ['analytics-heatmap'] });
    },
  });
};
